/**
 * The events that make up a participant's history, mirroring the backend's
 * `ParticipantActivityType`. Shared instead of copied per app: it used to be declared once per
 * frontend as a numeric enum sent by ordinal, and inserting QUESTIONNAIRE_RESET in the middle of
 * the backend enum silently shifted every logged activity by one (RDT-389).
 *
 * String-valued on purpose: the value is posted to `/activities/participant/{id}` as a JSON string
 * and matched by name, so an entry the backend does not know fails loudly instead of writing the
 * wrong event. The order carries no meaning any more.
 */
export enum ParticipantActivityType {
    PARTICIPANT_MOVED = "PARTICIPANT_MOVED",
    QUESTIONNAIRE_RESET = "QUESTIONNAIRE_RESET",
    PARTICIPANT_CREATED = "PARTICIPANT_CREATED",
    PARTICIPANT_ACTIVATED = "PARTICIPANT_ACTIVATED",
    QUESTIONNAIRE_MAIL_SENT = "QUESTIONNAIRE_MAIL_SENT",
    REMINDER_MAIL_SENT = "REMINDER_MAIL_SENT",
    CUSTOM_MAIL_SENT = "CUSTOM_MAIL_SENT",
    QUESTIONNAIRE_STARTED = "QUESTIONNAIRE_STARTED",
    QUESTIONNAIRE_COMPLETED = "QUESTIONNAIRE_COMPLETED",
    DIRECT_INPUT_SAVED = "DIRECT_INPUT_SAVED",
    PROFILE_SHARED = "PROFILE_SHARED",
    PROFILE_DOWNLOADED_BY_TRAINER = "PROFILE_DOWNLOADED_BY_TRAINER",
    PROFILE_DOWNLOADED_BY_PARTICIPANT = "PROFILE_DOWNLOADED_BY_PARTICIPANT",
    DATA_REVOKED = "DATA_REVOKED",
    DELETION_MAIL_SENT = "DELETION_MAIL_SENT",
    AUTO_DELETED = "AUTO_DELETED",
    PARTICIPANT_DELETED = "PARTICIPANT_DELETED",
    PROFILE_GENERATED = "PROFILE_GENERATED",
}
